import { useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UserPlus, Check, X } from "lucide-react";
import { toast } from "sonner";

// Picks a fair-only customer (separate from main customers), with inline create
export default function FairCustomerPicker({ value, onChange, customers, onCreated }) {
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ name: "", contact_name: "", phone: "" });

  const create = async () => {
    if (!form.name.trim()) { toast.error("Müşteri adı zorunlu"); return; }
    try {
      const r = await api.post("/fair/customers", form);
      await onCreated();
      onChange(r.data.id);
      toast.success("Fuar müşterisi oluşturuldu");
      setCreating(false); setForm({ name: "", contact_name: "", phone: "" });
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  if (creating) {
    return (
      <div className="rounded-md border border-[#D97706]/50 bg-[#EFE6D6] p-3 space-y-2" data-testid="fair-customer-quick-form">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
          {[["name", "Müşteri adı *"], ["contact_name", "Yetkili"], ["phone", "Telefon"]].map(([f, ph]) => (
            <Input key={f} placeholder={ph} value={form[f]} data-testid={`fair-customer-quick-${f}`}
              onChange={(e) => setForm({ ...form, [f]: e.target.value })} className="h-10 bg-[#FFFBF4] border-[#DCCFB8]" />
          ))}
        </div>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={() => setCreating(false)} data-testid="fair-customer-quick-cancel"
            className="h-9 border-[#DCCFB8] bg-transparent text-[#6B5B4A]"><X className="w-4 h-4 mr-1" /> Vazgeç</Button>
          <Button type="button" onClick={create} data-testid="fair-customer-quick-save" className="h-9 bg-[#D97706] hover:bg-[#B45309] text-white">
            <Check className="w-4 h-4 mr-1" /> Kaydet ve Seç</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-2">
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid="fair-customer-select" className="h-11 bg-[#EFE6D6] border-[#DCCFB8] flex-1">
          <SelectValue placeholder="Fuar müşterisi seçin..." />
        </SelectTrigger>
        <SelectContent className="bg-[#FFFBF4] border-[#DCCFB8] text-[#2B2118]">
          {customers.length === 0 && <div className="px-3 py-2 text-sm text-[#8C7B68]">Fuar müşterisi yok</div>}
          {customers.map((c) => (
            <SelectItem key={c.id} value={c.id} data-testid={`fair-customer-option-${c.id}`}>
              {c.name}{c.contact_name ? ` · ${c.contact_name}` : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button type="button" variant="outline" onClick={() => setCreating(true)} data-testid="fair-customer-new-btn"
        className="h-11 border-[#DCCFB8] bg-[#EFE6D6] text-[#B45309] hover:bg-[#FFFBF4] hover:text-[#B45309]">
        <UserPlus className="w-4 h-4 mr-1" /> Müşteri Oluştur
      </Button>
    </div>
  );
}
